export const tutorialLinks = {
  personalInfo: 'https://www.youtube.com/embed/K7_l4YfMN38',
  workExperience: 'https://www.youtube.com/embed/Hs8LeUDh_xc',
  education: 'https://www.youtube.com/embed/xpAGeXhV9d4',
  skills: 'https://www.youtube.com/embed/GwL4UfU5gvs',
  projects: 'https://www.youtube.com/embed/XDfEnoQu3Bo',
  expertTips: 'https://www.youtube.com/embed/XpUA2e6xqQU',
  previewToolbar: 'https://www.youtube.com/embed/GyZq0JQ-zcM',
  default: 'https://www.youtube.com/embed/poi9l_2LMsk',
};

export const labels = {
  expertTips: 'Expert tips tutorial',
  previewToolbar: 'Preview tutorial',
};

export const titles = {
  expertTips: 'Expert tips tutorial',
  previewToolbar: 'Preview tutorial',
};
